module.exports = __webpack_public_path__ + "img/40_69_011_730.fc154c06.jpg";